export default "__VITE_ASSET__DTlTWarz__"